import { NgModule } from '@angular/core';
import { SupportDevicesService } from './services';

@NgModule({
  providers: [SupportDevicesService]
})
export class DomainSupportDevicesModule {}